import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {KeyVarElement, Site} from '../../../../domain/cloud-topology';
import { SiteService } from '../../../../services/site/site.service';
import { FormControl, FormGroup } from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
    selector: 'app-site-charges',
    templateUrl: './charges.component.html',
    standalone: false
})
export class ChargesComponent implements OnInit, OnChanges {
  @Input() site: Site;
  clonedSite: Site;
  @Input() charges: KeyVarElement[];
  @Output() chargesFormDirty: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() chargesChange = new EventEmitter<KeyVarElement[]>();
  chargesForm: FormGroup;
  solarPPAEnabled: boolean;
  contractDemandEnabled: boolean;

  constructor(private siteService: SiteService,
              private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.clonedSite = this.site;
    this.solarPPAEnabled = false;
    this.contractDemandEnabled = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.charges) {
      this.chargesForm = new FormGroup({
        solarPPA: new FormControl(this.getChargeValue("solarPPA")),
        contractDemand: new FormControl(this.getChargeValue("contractDemand"))
      });

      if (this.chargesForm.get('solarPPA').value) {
        this.solarPPAEnabled = true;
      } else {
        this.chargesForm.get("solarPPA").disable();
        this.solarPPAEnabled = false;
      }

      if (this.chargesForm.get('contractDemand').value) {
        this.contractDemandEnabled = true;
      } else {
        this.chargesForm.get("contractDemand").disable();
        this.contractDemandEnabled = false;
      }
    } else {
      this.solarPPAEnabled = false;
      this.contractDemandEnabled = false;
    }
  }

  save(): void {
    if (window.confirm(`Are you sure you want to update charges for ${this.clonedSite.name}?`)){
      const formValues = this.chargesForm.value;
      this.siteService.putSiteCharges(this.clonedSite.id, formValues).subscribe(() => {
        this.chargesChange.emit([
          {key: 'contractDemand', value: (!this.chargesForm.get('contractDemand').disabled) ? this.chargesForm.get('contractDemand').value : 0},
          {key: 'solarPPA', value: (!this.chargesForm.get('solarPPA').disabled) ? this.chargesForm.get('solarPPA').value : 0},
        ]);
        this.chargesFormDirty.emit(false);
        this.snackBar.open(`${this.clonedSite.name}'s charges have been updated`, "Close",{
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "bottom"
        });
      }, () => {
        this.snackBar.open(`Problem saving charges for ${this.clonedSite.name}'s charges`, "Close",{
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "bottom"
        });
      })
    }
  }

  cancel(): void {
    if (window.confirm(`Are you sure you want to discard charge changes?`)) {
      this.chargesFormDirty.emit(false);
      this.chargesForm.reset({
        solarPPA: this.getChargeValue("solarPPA"),
        contractDemand: this.getChargeValue("contractDemand")
      });
    }
  }

  setDirtyForm() {
    this.chargesFormDirty.emit(true);
  }

  toggleField(inputField: string) {
    if(inputField === 'solarPPA') {
      if(this.solarPPAEnabled) {
        this.chargesForm.get(inputField).enable();
        setTimeout(() => this.chargesForm.get(inputField).enable(), 100);
      } else {
        this.chargesForm.get(inputField).setValue(null);
        this.chargesForm.get(inputField).disable();
        this.chargesForm.markAsDirty();
      }
    }

    if(inputField === 'contractDemand') {
      if(this.contractDemandEnabled) {
        this.chargesForm.get(inputField).enable();
      } else {
        this.chargesForm.get(inputField).setValue(null);
        this.chargesForm.get(inputField).disable();
        this.chargesForm.markAsDirty();
      }
    }

    this.setDirtyForm();
  }

  getChargeValue(fieldName: string): string {
    if (this.charges?.length > 0) {
      for (const chargeField of this.charges) {
        if(chargeField.key === fieldName) {
          return chargeField.value;
        }
      }
    }

    return '';
  }
}
